import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class PostsAdsFormBase extends FormBase {
    public getPostCards(root: ParentNode): HTMLElement[] {
        const cards = this.queryElements(root, `[data-role="${Roles.POST_CARD}"]`, HTMLElement);
        if (root instanceof HTMLElement && root.getAttribute("data-role") === Roles.POST_CARD) {
            return [root, ...cards];
        }

        return cards;
    }

    public getLinker(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".post-product-linker", HTMLElement);
    }

    public getPlaceholder(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.BOARD_MEDIA_AREA}"] [data-role="${Roles.BOARD_MEDIA_PLACEHOLDER}"]`,
            HTMLElement,
        );
    }

    public getProductIdInput(root: ParentNode): HTMLInputElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.POST_PRODUCT_LINKER_VIEW}"] [data-role="${Roles.POST_PRODUCT_ID}"]`,
            HTMLInputElement,
        );
    }

    public getBoardImage(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.BOARD_IMAGES_GRID}"] .board-image, .board-images-rail .board-image`,
            HTMLElement,
        );
    }

    public getBoardVideo(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_VIDEO_WRAP}"] .board-video-preview`, HTMLElement);
    }

    public getSnsTile(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.SNS_PREVIEW_TILES_GRID}"] [data-role="${Roles.SNS_PREVIEW_TILE}"], [data-role="${Roles.SNS_PREVIEW_TILES_GRID}"] [data-role="${Roles.SNS_PREVIEW_THUMB}"]`,
            HTMLElement,
        );
    }

    public getSnsData(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_SNS_LINKS_DATA}"][data-sns-links]`, HTMLElement);
    }

    public hasPostCard(root: ParentNode): boolean {
        return this.queryElement(root, `[data-role="${Roles.POST_CARD}"]`, HTMLElement) instanceof HTMLElement;
    }
}

const postsAdsFormBase = new PostsAdsFormBase();

export class PostsAdsForm {
    private readonly root: HTMLElement;

    public constructor(root: HTMLElement) {
        this.root = root;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public getPostCards(): HTMLElement[] {
        return postsAdsFormBase.getPostCards(this.root);
    }
}

export { postsAdsFormBase };
